import { COLORS } from '@btime/constants'
import { capitalizeIfLower, capitalizeSentenceIfLower } from '@btime/helpers'
import React from 'react'
import { compose, path } from 'ramda'

import { Title } from '../../../../components/presentation/Text'
import { WrapLoading } from '../../../../components/helpers/Loading'
import { useCanUpdateStatusChecker } from '../../../../utils/permissions/serviceOrders/canUpdateStatus'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'
import { useSaveEvent } from './_requests/saveEvent'
import { useOpenEditServiceOrderModal } from '../../../../utils/routes/modals/modalsActions'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import DateTimeIcons from '../../../../components/presentation/DateTimeIcons'
import DynamicPresentation from '../../../../containers/dynamic/DynamicPresentation'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import IconButton from '../../../../components/actions/IconButton'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'

const PendencyCard = ({ reply }) => {
  const navigate = useNavigation()
  const serviceOrder = useServiceOrder()
  const openEditModal = useOpenEditServiceOrderModal()

  const onReopen = () => {
    const pendencyName = compose(capitalizeIfLower, path(['value', 'name']))(reply)
    const pendencyDescription = compose(capitalizeSentenceIfLower, path(['value', 'description']))(reply)
    let description = `Motivo da pendencia: \n${pendencyName}`
    if (pendencyDescription) description += `\n\nAnotações: \n${pendencyDescription}`
    openEditModal({ initialState: { parentId: serviceOrder.id, description }, cloneFromId: serviceOrder.id })
  }

  const canUpdate = useCanUpdateStatusChecker(serviceOrder, 'completed')
  const [onComplete, { loading }] = useSaveEvent('completed')

  return (
    <Panel lineBorder mediumPadding borderLeftColor={COLORS.purple}>
      <FlexGrid justify="space-between" align="flex-start" gutter={0.3}>
        <FlexCol flex={1}>
          <Title size="h6">{capitalizeIfLower(reply.question.name)}</Title>
          <Separator weight={2} />
          <div>
            <DynamicPresentation type={reply.question.type.name} value={reply.value} />
          </div>

          <Separator weight={4} />
          <DateTimeIcons date={reply.insertedAt} gutter={0.5} />
        </FlexCol>

        {!!canUpdate && (
          <WrapLoading loading={loading}>
            <IconButton
              icon="BsArrowCounterclockwise"
              color={COLORS.purple}
              borderColor={COLORS.purple}
              label="Reabrir Atividade"
              onClick={onReopen}
              transparent
              small
            />
            <IconButton icon="BsCheckCircle" color={COLORS.green} label="Finalizar" onClick={onComplete} small />
          </WrapLoading>
        )}
      </FlexGrid>
    </Panel>
  )
}

export default PendencyCard
